import * as React from 'react';
// import * as ReactDOM from 'react-dom';
import * as ReactDOM from 'react-dom/client';
import './index.css';
import 'antd/dist/antd.css';
import Routes from './Routes';

// import 'ant-design-pro/dist/ant-design-pro.css';


// ReactDOM.render(<Routes />, document.getElementById("root") as
// HTMLElement);

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  
  // Render your app
  root.render(
    <React.StrictMode>
      <Routes />
    </React.StrictMode>
  );